import store from 'redux/store'
import { getFinalPriceMdl22Service } from 'redux/services/clientsServices'
import { isWebDocumentOrigin } from 'Utils/isWebDocumentOrigin'

const findAvailableProductIndex = (products, item, usedIndexes) => {
  const matchingIndexes = products.reduce((indexes, product, index) => {
    const productData = product.product || product
    if (
      productData.ProductId?.toUpperCase() !== item.ProductId?.toUpperCase()
    ) {
      return indexes
    }

    indexes.push(index)
    return indexes
  }, [])

  return (
    matchingIndexes.find(index => !usedIndexes.has(index)) ?? matchingIndexes[0]
  )
}

// Empareja cada precio con un producto distinto del carrito: usar solo
// ProductId puede colapsar líneas duplicadas (ej. el SKU dummy de LITA)
// en un único producto si se usa `.find()` directamente.
export const matchPricesToProducts = (products, prices, warehouse) => {
  const usedIndexes = new Set()

  return prices.map(item => {
    const productIndex = findAvailableProductIndex(products, item, usedIndexes)
    if (productIndex != null) usedIndexes.add(productIndex)

    const product = productIndex != null ? products[productIndex] : {}
    const Quantity = product?.qty || 0
    const Price = item.FinalPrice

    return {
      selectList: { ...item, Quantity, Price },
      payload: { ...product, Quantity, Price },
      warehouse,
      Quantity,
      Price,
      qty: Quantity,
    }
  })
}

export const fethCheckFinalPrice = async (
  prod,
  customerId,
  newCompany,
  isCompanyChange = false
) => {
  const company = store.getState().company
  const quoteHeader = store.getState().cotizacion?.QuoteHeader

  // The previous company's price list is not valid in the new company
  const PriceListId = isCompanyChange ? undefined : quoteHeader?.PriceListId
  const ProductIds = prod.map(product => product.product.ProductId)
  const WarehouseId = newCompany?.WarehouseId || company.WarehouseId
  const WarehouseCode = newCompany?.WarehouseCode || company.WarehouseCode
  const WarehouseDescription =
    newCompany?.WarehouseDescription || company.WarehouseDescription
  const CompanyId = newCompany?.CompanyId || company.CompanyId

  const warehouse = {
    WarehouseId,
    WarehouseCode,
    WarehouseDescription,
    WarehouseAddress: quoteHeader?.WarehouseAddress,
  }

  const mapByProductId = selectList =>
    matchPricesToProducts(prod, selectList, warehouse)

  const isSaleOrderWeb = isWebDocumentOrigin(quoteHeader?.Origin)

  if (!isSaleOrderWeb) {
    const finalPricePayload = {
      CompanyId,
      WarehouseId,
      ProductIds,
      ...(customerId ? { CustomerId: customerId } : { PriceListId }),
    }

    const response = await getFinalPriceMdl22Service(finalPricePayload)
    const { data, status } = response

    if (status === 200 && data?.Data) {
      return mapByProductId(data.Data)
    }
    // Otherwise every product would look like it has no price
    throw new Error(`Final price request failed with status ${status}`)
  } else {
    return mapByProductId(quoteHeader?.Lines)
  }
}
